import React from "react";
import {connect} from "react-redux";
import {bindActionCreators, compose} from "redux";
import {styles} from "./../../styles/documents";
import {withStyles} from "@material-ui/core/styles";
import {modifyComment} from "@componentDP/js_react/redux/actions/zajavls";
import TextField from '@material-ui/core/TextField';
import {getCommentFromCommentsZajavls} from "@helpers/functions";
import {withTranslation} from "react-i18next";

class Comment extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(e) {
        const {zajavlUuidConfirm, modifyComment} = this.props;
        modifyComment(zajavlUuidConfirm, e.target.value);
    }
    render() {
        const {handleChange} = this;
        const {commentsZajavls, zajavlUuidConfirm, t} = this.props;
        const commentValue = getCommentFromCommentsZajavls(commentsZajavls, zajavlUuidConfirm);
        return(
            <TextField
                label={t('action_comment')}
                value={commentValue}
                onChange={handleChange}
                variant="outlined"
                multiline={true}
                minRows={2}
                fullWidth/>
        );
    }
}

function mapStateToProps(state) {
    const {commentsZajavls} = state;
    return {
        commentsZajavls,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        modifyComment,
    }, dispatch);
}

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(withTranslation()(Comment));
